import { Text, TextProps } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { crm } from "../../theme";
import { formatSince } from "../../utils/duration";

/** Contador vivo "há X" desde `since` (ISO de Brasília). Atualiza a cada minuto. */
const StatusTimer = ({
  since,
  prefix = "há ",
  suffix = "",
  ...rest
}: { since?: string | null; prefix?: string; suffix?: string } & TextProps) => {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!since) return;
    const id = window.setInterval(() => setTick((t) => t + 1), 60000);
    return () => window.clearInterval(id);
  }, [since]);

  const text = formatSince(since);
  if (!text) return null;

  return (
    <Text as="span" fontSize="xs" color={crm.textMuted} title="Tempo no status atual" {...rest}>
      {prefix}
      {text}
      {suffix}
    </Text>
  );
};

export default StatusTimer;
